import type { Environment } from '../app/models/environment.model';


export const environment: Environment = {
  production: true,
  environmentName: 'prod',
  msal: {
    clientId: 'e2e7abd0-df2e-4d2f-82be-a0f50f70a8a3',
    tenantId: '8e4a72ef-928b-45b6-a137-7ed7bb318678',
    authority: 'https://login.microsoftonline.com/8e4a72ef-928b-45b6-a137-7ed7bb318678/oauth2/v2.0/token',
    redirectUri: 'https://workassist.abm.com',
    postLogoutRedirectUri: 'https://workassist.abm.com/logged-out',
    scopes: [
      'openid',
      'profile',
      'api://5795d405-d098-4e99-a398-01dac8021f78/access_as_user'
    ],
  },
  apiConfig: {
    scopes: ['api://5795d405-d098-4e99-a398-01dac8021f78/access_as_user'],
    serverBaseUrl: 'https://api.workassist.abm.com/core/',
    ocpApimSubscriptionKey: '3e90b88a12f944139c679e9c0d308be2',
  },
};
